// extracted by mini-css-extract-plugin
export default {"paymentIssueTable":"kUYUaIXPOHp7zBjjpSfn"};